import { NavigationGuard } from 'vue-router';
import store from '../store';

function checkSpaceRoute(to: any) {
   if (to.query?.board_id) return;

   const boardId = to.query?.board_id;
   const isGoingToBoard = to.path.includes('/board');

   if (boardId && isGoingToBoard) {
      return {
         name: to.name,
         query: { ...to.query, planning_view: to.query.planning_view ?? 'candidate' },
         params: { ...to.params, board_id: boardId.toString() },
      };
   }

   return;
}

export const SPACE_GUARD: NavigationGuard = async (to, from) => {
   if (to.name && to.name !== 'unavailable') localStorage.setItem('lastRoute', to.fullPath);

   if (store.state.history.length == 10) store.state.history.splice(0, 1);
   store.state.history.push(window.location.origin + to.fullPath);

   if (to.meta.title) setDocumentTitle(to.meta.title, store.state);

   const CHECKED_SPACE_ROUTE = checkSpaceRoute(to);
   if (CHECKED_SPACE_ROUTE) return CHECKED_SPACE_ROUTE;
};
